module.exports = __webpack_public_path__ + "static/media/izmeritelnye_preobrazovateli_ovt.3d96f92e.pdf";